import { render, staticRenderFns } from "./Deconnection.vue?vue&type=template&id=f827d1be&scoped=true"
import script from "./Deconnection.vue?vue&type=script&lang=js"
export * from "./Deconnection.vue?vue&type=script&lang=js"
import style0 from "./Deconnection.vue?vue&type=style&index=0&id=f827d1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f827d1be",
  null
  
)

export default component.exports